module.exports = __webpack_public_path__ + "img/icon-ellipse-active.30ebc552.svg";